import { clone, fromPairs, compose, reverse, append, __ } from 'ramda';

const props = ['L1', 'A1', 'V1', 'I1', 'L2', 'A2', 'V2', 'I2'];

const adjectiveToProperty = {
  'alentador': 'FD 8',
  'analitico': 'FI 7',
  'artistico': 'FD 8',
  'competitivo': 'FI 7',
  'confiable': 'PD 2',
  'conservador': 'PI 1',
  'creativo': 'FD 8',
  'cuantitativo': 'FI 7',
  'decisivo': 'FI 7',
  'firme': 'FI 7',
  'detallista': 'PI 1',
  'empatico': 'PD 2',
  'espacial': 'FD 8',
  'espiritual': 'PD 2',
  'laborioso': 'PI 1',
  'logico': 'FI 7',
  'matematico': 'FI 7',
  'metaforico': 'FD 8',
  'metodico': 'PI 1',
  'minucioso': 'PI 1',
  'objetivo': 'FI 7',
  'personal': 'PD 2',
  'precavido': 'PI 1',
  'sensible': 'PD 2',
  'sensitivo': 'PI 1',
  'sentimental': 'PD 2',
  'simultaneo': 'FD 8',
  'sintetizador': 'FD 8',
  'tranquilizador': 'PD 2',
};



export default {
  props: () => clone(props),
  adjectiveToProperty,
  default: () => ({
    L1: 0,
    A1: 0,
    V1: 0,
    I1: 0,
    L2: 0,
    A2: 0,
    V2: 0,
    I2: 0
  })
};



// WEBPACK FOOTER //
// ./src/App/benzinger/Benzinger.js